"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeITxBuildInputInlineScript = void 0;
var CanBeData_1 = require("../../utils/CanBeData.js");
function normalizeITxBuildInputInlineScript(input) {
    var result = {};
    result.script = input.script.clone();
    result.datum = (input.datum === "inline" ? "inline" :
        ((0, CanBeData_1.canBeData)(input.datum) ? (0, CanBeData_1.forceData)(input.datum) :
            undefined));
    result.redeemer = (0, CanBeData_1.forceData)(input.redeemer);
    return result;
}
exports.normalizeITxBuildInputInlineScript = normalizeITxBuildInputInlineScript;
